





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IBlock, ISortParameters, ITransaction } from "../../interfaces";
import TransactionService from "@/services/transaction";

@Component
export default class BlockTransactions extends Vue {
  @Prop({ required: true }) public block: IBlock;

  public transactions: ITransaction[] | null = null;
  private meta: any | null = null;

  get sortParams(): ISortParameters {
    return this.$store.getters["ui/transactionSortParams"];
  }

  set sortParams(params: ISortParameters) {
    this.$store.dispatch("ui/setTransactionSortParams", {
      field: params.field,
      type: params.type,
    });
  }

  @Watch("block")
  public onBlockChanged() {
    this.resetTransactions();
    this.getTransactions();
  }

  public mounted() {
    this.resetTransactions();
    this.getTransactions();
  }

  private resetTransactions(): void {
    this.transactions = null;
  }

  private async getTransactions(): Promise<void> {
    if (!this.block.block_id) {
      return;
    }
  }

  private onSortChange(params: ISortParameters): void {
    this.sortParams = params;
  }
}
